// Shared "manager's own case list" query. One `['cases']` key for every
// consumer — previously `ManagerMobile.tsx` used a divergent
// `['manager', 'cases']` key, which meant (a) it never shared a cache entry
// with sibling tabs under the same mobile shell (Team/Maeve), so switching
// tabs refetched the identical unfiltered `/api/cases` payload, and (b) it
// was never invalidated by `ManagerNewCase.tsx`/`ManagerCaseDetail.tsx`'s
// `invalidateQueries({ queryKey: ['cases'] })`, so the mobile Home tab could
// show a stale case list after creating or updating a case.

import { useQuery } from '@tanstack/react-query';
import type { CaseSummary } from '@besideu/shared/cases';
import { api } from '@/lib/api.ts';

// No options. It carried an `enabled` passthrough for exactly one caller:
// `ManagerDashboard` mounted BOTH this and the paginated list in one tree and
// gated each on `useMediaQuery` so only one fired per load. Since PO
// 2026-08-06 those live on two different pages (`/manager` and
// `/manager/team`), so the gate is gone and nothing passes the option —
// leaving it would imply a viewport branch that no longer exists anywhere.
export function useCases() {
  return useQuery({
    queryKey: ['cases'],
    queryFn: () => api.get<{ cases: CaseSummary[] }>('/api/cases'),
  });
}
